@tailwind base;
@tailwind components;
@tailwind utilities;


:host {
  display: block;
}

@keyframes loading-bar {
  0% {
    transform: translateX(-100%) scaleX(0.5);
  }
  25% {
    transform: translateX(0%) scaleX(1);
  }
  50% {
    transform: translateX(100%) scaleX(0.5);
  }
  75% {
    transform: translateX(0%) scaleX(1);
  }
  100% {
    transform: translateX(-100%) scaleX(0.5);
  }
}
.animate-loading-bar {
  animation: loading-bar 2s ease-in-out infinite;
}


@keyframes slide-in {
  0% {
    width: 0%;
  }
  100% {
    width: 100%;
  }
}
.animate-slide-in {
  animation: slide-in 1.5s ease-in-out forwards;
}

@keyframes fade-in-grow {
  0% {
    opacity: 0;
    transform: scaleX(0.25);
  }
  100% {
    opacity: 1;
    transform: scaleX(1);
  }
}
.animate-fade-in-grow {
  animation: fade-in-grow 0.5s ease-in-out forwards;
}

@keyframes fade-out {
  from {
    opacity: 1;
    transform: scaleX(1);
  }
  to {
    opacity: 0;
    transform: scaleX(0.25);
  }
}
.animate-fade-out {
  animation: fade-out 0.5s forwards;
}
